<template>
    <div>
        <div class="c-row" v-for="(billing, idx) in data.promotions" :key="idx">
            <div class="c-tr">
                <div class="c-tw">
                    <div class="c-td">
                        <div class="typo-label">Promocja</div>
                        {{ billing.name }}
                    </div>
                    <div class="c-td">
                        <div class="typo-label">Producent</div>
                        {{ billing.producer.name }}
                    </div>
                    <div class="c-td">
                        <div class="typo-label">Data użycia</div>
                        {{ $moment(billing.usageDate).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                    <div class="c-td">
                        <div class="typo-label">Data rejestracji</div>
                        {{ $moment(billing.registerDate).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                    <div class="c-td">
                        <div class="typo-label">Tydzień rozliczeniowy</div>
                        {{ billing.settlementWeek }}
                    </div>
                    <div class="c-td">
                        <div class="typo-label">Status</div>
                        {{ billing.usageStatus }}
                    </div>
                    <div class="c-td">
                        <div class="typo-label">Liczba użyć</div>
                        {{ billing.used }}
                    </div>
                    <div class="c-td">
                        <div v-tooltip="'Prognozowany Zwrot Kosztów'"
                            class="d-flex align-items-center"
                        >
                            <span class="typo-label">Zwrot Kosztów</span>
                            <a-icon class="typo-label icon"
                                icon="Info"
                                style="width: 16px; height: 16px"
                            />
                        </div>
                        {{ billing.refund | currency }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statuses from '@/dictionaries/promoBillings.json'

export default {
    data() {
        return {
            showShops: false,
            statuses
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        companyName() {
            return this.$store.getters.getCompanyById(
                this.data.promo.company_id
            )
        }
    }
}
</script>